/**
 * Created by Eran.Shain on 2/20/2017.
 */
export const SWWidget = {};
export default SWWidget;
